import { render } from "./HistogramSlider.vue?vue&type=template&id=56810062&scoped=true"
import script from "./HistogramSlider.vue?vue&type=script&lang=js"
export * from "./HistogramSlider.vue?vue&type=script&lang=js"

import "./HistogramSlider.vue?vue&type=style&index=0&id=56810062&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56810062"]])

export default __exports__